import { __awaiter, __generator } from "tslib";
import { useEffect, useState, useRef } from 'react';
import { getCachedModule, getAppData, processManifest, getScalprum } from '@scalprum/core';
export function useLoadModule(_a, defaultState) {
    var _this = this;
    var scope = _a.scope, module = _a.module, processor = _a.processor;
    var manifestLocation = getAppData(scope).manifestLocation;
    var _b = useState(defaultState), data = _b[0], setData = _b[1];
    var _c = useState(), error = _c[0], setError = _c[1];
    var cachedModule = getCachedModule(scope, module).cachedModule;
    var isMounted = useRef(true);
    var pluginStore = getScalprum().pluginStore;
    useEffect(function () {
        if (isMounted.current) {
            if (!cachedModule) {
                if (manifestLocation) {
                    processManifest(manifestLocation, scope, module, processor)
                        .then(function () { return __awaiter(_this, void 0, void 0, function () {
                        var Module;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, pluginStore.getExposedModule(scope, module)];
                                case 1:
                                    Module = _a.sent();
                                    setData(function () { return Module; });
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        setError(function () { return e; });
                    });
                }
            }
            else {
                try {
                    pluginStore.getExposedModule(scope, module).then(function (Module) {
                        setData(function () { return Module; });
                    });
                }
                catch (e) {
                    setError(function () { return e; });
                }
            }
        }
        return function () {
            isMounted.current = false;
        };
    }, [scope, cachedModule]);
    return [data, error];
}
//# sourceMappingURL=use-load-module.js.map